export const formatAsDollars = (value: number, options = { cents: true }): string => {
  const sign = value < 0 ? '-' : '';
  const absValue = Math.abs(value);
  const amount = options.cents ? absValue / 100 : absValue;

  return `${sign}$${amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const toLocaleDateString = (value?: string) =>
  value ? new Date(value).toLocaleDateString() : '';

export const capitalize = (text: string): string => {
  return text.split('').reduce((result, char, index) => {
    if (index === 0) return result + char.toUpperCase();
    return result + char.toLowerCase();
  }, '');
};

export const currencyStringToNumber = (currencyString: string): number => {
  if (!currencyString) return 0;
  // Remove the dollar sign and commas, and strip any spaces
  const cleanedString =
    typeof currencyString === 'string'
      ? currencyString.replace(/[$,]/g, '').trim()
      : currencyString;

  // Convert the cleaned string to a number and multiply by 100 to eliminate the decimal
  const numberValue = Math.round(parseFloat(cleanedString) * 100);

  return numberValue;
};

export const generateRandomString = (length: number = 5): string => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
};

const parseDateString = (dateString: string): Date => {
  const parts = dateString.split('-') as [string, string, string];

  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1; // Months are 0-based in JavaScript
  const day = parseInt(parts[2], 10);

  return new Date(year, month, day);
};

export const setSemesterCodeString = (date: string): string => {
  const parsedDate = parseDateString(date);
  const month = parsedDate.getMonth();
  const year = parsedDate.getFullYear();

  let semester: 'Spring' | 'Summer' | 'Fall';
  if (month <= 3) {
    semester = 'Spring';
  } else if (month <= 6) {
    semester = 'Summer';
  } else {
    semester = 'Fall';
  }

  // Compute the academic‐year span
  //  – Fall:  year -> year+1
  //  – Spring/Summer: (year-1) -> year
  const [startYear, endYear] = semester === 'Fall' ? [year, year + 1] : [year - 1, year];

  return `${startYear}-${endYear} ${semester}`;
};

export function snakeCase(str: string): string {
  return (
    str
      // Insert an underscore between lower & upper case (e.g. "someKey" -> "some_Key")
      .replace(/([a-z])([A-Z])/g, '$1_$2')
      // Convert spaces/dashes to underscores
      .replace(/[\s-]+/g, '_')
      // Convert everything to lowercase
      .toLowerCase()
  );
}

export function formatCamelCase(str: string): string {
  if (!str) return '';

  // Insert space before capital letters and capitalize the first letter
  const spaced = str.replace(/([A-Z])/g, ' $1');

  // Capitalize the first letter and trim any extra spaces
  return spaced.charAt(0).toUpperCase() + spaced.slice(1).trim();
}

export default null; // silence a false warning
